<template>
    <v-container fluid fill-height>
        <EmailEditor/>
    </v-container>
</template>

<script>
    import EmailEditor from "../components/EmailEditor";

    export default {
        components:{
            EmailEditor
        }
    }
</script>

<style scoped>

    .unlayer-editor {
        height: 90%;
        width: 100%;
    }

</style>